<select #selector class="multiple-select">
  <ng-content select="option, optgroup">
  </ng-content>
</select>